import { Box } from "@mui/material";
import FarmOverviewPanel from "../../components/dashboard/FarmOverviewPanel";

export default function AnimalDashboard() {
  return (
    <Box
      sx={{
        minHeight: "100%",
        pb: 4,
        pt: { xs: 2, md: 3 },
        px: { xs: 2, md: 3 },
        bgcolor: "background.default",
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: "auto" }}>
        <FarmOverviewPanel sectionTitle="Animal dashboard" pageLayout />
      </Box>
    </Box>
  );
}
